import { render, staticRenderFns } from "./SettingCustomersCustomer.vue?vue&type=template&id=363f7cde&"
import script from "./SettingCustomersCustomer.vue?vue&type=script&lang=ts&"
export * from "./SettingCustomersCustomer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports